import { useEffect, useState } from "react";

import { Column } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";

import { CartonView } from "../../../models/carton";
import { DecimalFormatType, formatDecimalValue } from "../../../util/formatDecimalValue";
import { getMeasurement, getWeightMeasurement } from "../../../util/getMeasurement";
import { paginate } from "../../../util/paginate";
import { SearchAttribute } from "../../Generic/CartonSSCC/util";

interface UseBookingFilesProps {
  cartons: CartonView[];
}
export const useBookingVolumeAndWeight = ({ cartons }: UseBookingFilesProps) => {
  const { t: translate } = useTranslation();
  const [filteredCartons, setFilteredCartons] = useState<CartonView[]>([]);
  const [searchAttributes, setSearchAttributes] = useState<SearchAttribute[]>([]);
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const measurement = getMeasurement();
  const measurementWeight = getWeightMeasurement();

  const filterCartons = (searchAttributes: SearchAttribute[]) => {
    return searchAttributes.reduce((filteredProducts, searchAttribute) => {
      return filteredProducts.filter((carton: any) =>
        searchAttribute.values.some((value) =>
          String(carton[searchAttribute.attribute])?.toLowerCase().includes(value.toLowerCase())
        )
      );
    }, cartons);
  };

  useEffect(() => {
    if (searchAttributes.length > 0) {
      const filteredProducts = filterCartons(searchAttributes);

      setFilteredCartons(paginate(filteredProducts, page, pageSize));
      setTotalItems(filteredCartons.length);
    } else {
      setFilteredCartons(paginate(cartons, page, pageSize));
      setTotalItems(cartons.length);
    }
  }, [page, pageSize, searchAttributes, cartons]);

  const columns: Column[] = [
    {
      name: "sscc",
      title: translate("sscc"),
      searchIdentifier: "sscc",
    },
    {
      name: "cartonQty",
      title: translate("quantity"),
      searchIdentifier: "cartonQty",
      hideSearch: true,
    },
    {
      name: "measurement",
      title: `${translate("volume")} (${(measurement?.code || "")?.toUpperCase()})`,
      formatText: (value: number) => formatDecimalValue(DecimalFormatType.MAERSK, value || 0),
      searchIdentifier: "measurement",
      hideSearch: true,
    },
    {
      name: "grossWeight",
      title: `${translate("weight")} (${(measurementWeight?.code || "")?.toUpperCase()})`,
      formatText: (value: number) => formatDecimalValue(DecimalFormatType.MAERSK, value || 0),
      searchIdentifier: "grossWeight",
      hideSearch: true,
    },
  ];

  return {
    filteredCartons,
    columns,
    setSearchAttributes,
    setPage,
    page,
    pageSize,
    setPageSize,
    totalItems,
  };
};
